<div class="button-wrapper">
	<div class="options-wrapper" #optionsWrapper>
		<span
			*ngFor="let item of options"
			[id]="item.action"
			[matTooltip]="item.title"
			matTooltipPosition="right"
			[class.disabled]="item.disabled"
			class="bubble-button"
			(click)="selectOption(item)"
		>
			<mat-icon>{{item.icon}}</mat-icon>
		</span>
	</div>

	<div class="bubble-button" (click)="toggleButton()" [class.opened]="opened">
		<mat-icon>more_vert</mat-icon>
	</div>
</div>

